import { render, staticRenderFns } from "./PronosticoMeteorologicoFooter.vue?vue&type=template&id=62969977&scoped=true"
import script from "./PronosticoMeteorologicoFooter.vue?vue&type=script&lang=ts"
export * from "./PronosticoMeteorologicoFooter.vue?vue&type=script&lang=ts"
import style0 from "./PronosticoMeteorologicoFooter.vue?vue&type=style&index=0&id=62969977&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62969977",
  null
  
)

export default component.exports